$(()=>{

    App.Video = {

        init: function(){

            $('.js--video-player:not(._init-video-player)').each(function(){

                let $component = $(this),
                    $video = $('.js--video-player-video', $component),
                    $play = $('.js--video-player-play', $component);

                $component.addClass('_init-video-player');

                let currentTime = $component.attr('data-current-time');
                if (currentTime != undefined) {
                    $video[0].currentTime = parseInt(currentTime);
                }

                let pauseTimeout;

                $video.on('play', function(e){

                    $video[0].controls = true;
                    $component.addClass('_play');

                    clearTimeout(pauseTimeout);

                });

                $video.on('pause', function(e){

                    pauseTimeout = setTimeout(function(){

                        $video[0].controls = false;
                        $component.removeClass('_play');

                    }, 100);

                });

                $play.on('click', function(e){
                    e.preventDefault();

                    $video[0].play();

                });

            });

        }
    };
    App.Video.init();

});